<ng-container [ngSwitch]="loaderType">
  <div
    class="skeleton-loader-container"
    *ngSwitchCase="skeletonLoaderType.PROFILE"
  >
    <div class="circle-loader"></div>
    <div
      *ngFor="let line of [].constructor(lineCount)"
      class="line-loader"
    ></div>
  </div>
  <div
    class="skeleton-loader-container"
    *ngSwitchCase="skeletonLoaderType.LINE"
  >
    <div
      *ngFor="let line of [].constructor(lineCount)"
      class="line-loader"
    ></div>
  </div>

  <div
    class="skeleton-loader-container column"
    *ngSwitchCase="skeletonLoaderType.COLUMN"
  >
    <div
      *ngFor="let line of [].constructor(lineCount)"
      class="line-loader"
    ></div>
  </div>
</ng-container>
